import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestInventoryMoveMutationVariables = Types.Exact<{
  input: Types.RequestInventoryMoveInput;
}>;


export type RequestInventoryMoveMutation = { readonly __typename?: 'Mutation', readonly requestInventoryMove: { readonly __typename?: 'InventoryMoveRequest', readonly id: string } };


export const RequestInventoryMoveDocument = gql`
    mutation requestInventoryMove($input: RequestInventoryMoveInput!) {
  requestInventoryMove(input: $input) {
    id
  }
}
    `;
export type RequestInventoryMoveMutationFn = Apollo.MutationFunction<RequestInventoryMoveMutation, RequestInventoryMoveMutationVariables>;

/**
 * __useRequestInventoryMoveMutation__
 *
 * To run a mutation, you first call `useRequestInventoryMoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInventoryMoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInventoryMoveMutation, { data, loading, error }] = useRequestInventoryMoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestInventoryMoveMutation(baseOptions?: Apollo.MutationHookOptions<RequestInventoryMoveMutation, RequestInventoryMoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestInventoryMoveMutation, RequestInventoryMoveMutationVariables>(RequestInventoryMoveDocument, options);
      }
export type RequestInventoryMoveMutationHookResult = ReturnType<typeof useRequestInventoryMoveMutation>;
export type RequestInventoryMoveMutationResult = Apollo.MutationResult<RequestInventoryMoveMutation>;
export type RequestInventoryMoveMutationOptions = Apollo.BaseMutationOptions<RequestInventoryMoveMutation, RequestInventoryMoveMutationVariables>;